type OffersRedirectInputs = {
  redirectUrl?: string;
  storeUuid?: string;
  offerId?: string;
  offersUrl: string;
};

const toUrl = (value: string): URL | null => {
  try {
    return new URL(value);
  } catch {
    return null;
  }
};

const isTrustedOffersUrl = (candidate: string, offersUrl: string): boolean => {
  const url = toUrl(candidate.trim());
  const offers = toUrl(offersUrl);
  if (!url || !offers) return false;
  return url.protocol === 'https:' && url.origin === offers.origin;
};

export const resolveOffersRedirect = (inputs: OffersRedirectInputs): string | null => {
  const { redirectUrl, storeUuid, offerId, offersUrl } = inputs;
  if (redirectUrl && isTrustedOffersUrl(redirectUrl, offersUrl)) return redirectUrl;
  if (storeUuid && offerId) return `${offersUrl}/?id=${storeUuid}`;
  return null;
};
